/// <reference path="../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import MonitoringRoom = Models.MonitoringRoom;
    import Monitor = Models.Monitor;
    import Utils = Common.Utils;

    interface ISelectOption {
        value: string;
        text: string;
    }

    /**
     * MonitoringRoomController class
     */
    export class MonitoringRoomController {
        public static $name: string = "monitoringRoomController";
        public static $inject: string[] = ['$scope',
                                           '$q',
                                           'ModalService',
                                           'monitoringRoomService',
                                           'connectionRoomService',
                                           '$cookies',
                                           '$timeout',
                                           '$document',
                                           '$window',
                                           'stompService',
                                           '$rootScope',
                                           '$location',
                                           'aclService',
                                           'streamPipeService',
                                           'flexCollectorService',
                                           'messageTranslationsService',
                                           'userService',
                                           ];
        public static ASPECT_RATIO: number = 16 / 9;
        public static TRENDING_COOKIE_KEY: string = 'flex_monitoring_trending';
        public static COOKIE_OPTIONS: ng.cookies.ICookiesOptions = 
                    { expires: Common.Utils.getCookieExpirationDate(), secure:  location.protocol === 'https:'  };
        private static TIMEOUT_RESIZING: number = 200;

        public firstAdjustmentDone: boolean = false;

        public selectedMonitoringRoom: Models.IMonitoringRoom;
        public matchedMonitors: Models.IMonitor[];
        public userIsAdmin: boolean;

        private cookieKey: string = 'flex_monitoringroom_selectedroom';
        private monitoringRooms: Models.MonitoringRoom[];
        private showTrending: boolean;
        private resizeTimer: ng.IPromise<void>;
        private currentPage: number;
        private monitorsPerPage: number;
        private totalPagesRange: number[];
        private totalPageNumber: number;
        private subscription: Services.IEventSubscription;
        private miniSidebarWatcher: Function;
        private windowWidthWatcher: Function;
        private userCanWriteRoom: boolean;
        private searchText: string;
        private kiosk: boolean;

        private timeoutSearch: ng.IPromise<void>;
        private timeoutResize: ng.IPromise<void>;
        private timeoutPagination: ng.IPromise<void>;
        
        constructor(private $scope: ng.IScope,
                    private qService: ng.IQService,
                    private modalService: ngModal.IModalService,
                    private monitoringRoomService: Services.MonitoringRoomService,
                    private connectionRoomService: Services.ConnectionRoomService,
                    private $cookies: ng.cookies.ICookiesService,
                    private $timeout: ng.ITimeoutService,
                    private $document: ng.IDocumentService,
                    private $window: ng.IWindowService,
                    private stompService: Services.StompService,
                    private $rootScope: Services.IFlexSettings,
                    private $location: ng.ILocationService,
                    private aclAservice: Services.AclService,
                    private streamPipeService: Services.StreamPipeService,
                    private flexCollectorService: Services.FlexCollectorService,
                    private messageTranslationsService: Services.MessageTranslationsService,
                    private userService: Services.UserService) {
            this.showTrending = false;
            this.kiosk = this.$rootScope.kiosk;
            this.loadTrendingStatus();
            this.loadMonitorRooms();
            this.currentPage = 0;
            this.searchText = "";
            this.userCanWriteRoom = false;
            $rootScope.alarmConsoleHidden = false;
            if(!$rootScope.alarmConsoleSticky)
                $rootScope.alarmConsoleSticky = false;
            $rootScope.alarmConsoleHidden =
                $rootScope.alarmConsoleSticky ? false : $rootScope.settings.alarmConsoleHiddenInMonitoring || $rootScope.kiosk;
            this.userService.loadCurrentUser().then((user: Models.IUser) => {
                this.userIsAdmin = user.authorities.some((auth: Models.IAuthority) => {
                    return auth.authority === 'ROLE_ADMIN';
                });
            });

            this.bindEvents();
        }

        public changeTrending(): void {
            let cookieVal: string = this.showTrending ? 'true' : 'false';
            this.$cookies.put(MonitoringRoomController.TRENDING_COOKIE_KEY, cookieVal, MonitoringRoomController.COOKIE_OPTIONS);
            this.updatePaginationInfo();
            this.currentPage = 0;
            this.adjustThumbnailsSize();
            this.monitoringRoomService.notifyTrendingSwitch(Common.Utils.idFromHref(this.selectedMonitoringRoom.href), this.showTrending);
        }

        public changeRoom(): void {
            this.firstAdjustmentDone = false;
            this.$timeout(() => {
                this.$cookies.put(this.cookieKey,
                                  Common.Utils.idFromHref(this.selectedMonitoringRoom.href).toString(),
                                  MonitoringRoomController.COOKIE_OPTIONS);
                this.adjustThumbnailsSize();
                this.currentPage = 0;
                this.searchText = "";
                this.updatePaginationInfo();
                this.selectedMonitoringRoom.monitors = [];
                this.matchedMonitors = [];
                this.loadMonitorRooms();
            });
        }

        public saveMonitor(monitor: Models.IMonitor): void {
            monitor.monitorRoom = this.selectedMonitoringRoom.href;
            this.monitoringRoomService
                .saveMonitor(monitor)
                .then((element: Models.IMonitor) => {
                    for (let i: number = 0; i < this.selectedMonitoringRoom.monitors.length; i++) {
                        if (this.selectedMonitoringRoom.monitors[i].href === element.href) {
                            this.selectedMonitoringRoom.monitors[i] = element;
                            this.applyFilter();
                            break;
                        }
                    }
                    for (let i: number = 0; i < this.monitoringRooms.length; i++) {
                        if (this.monitoringRooms[i].href === this.selectedMonitoringRoom.href) {
                            this.monitoringRooms[i] = this.selectedMonitoringRoom;
                            break;
                        }
                    }
                });
        }

        public loadTrendingStatus(): void {
            if ( this.$location.search().trending !== undefined ) {
                this.showTrending = this.$location.search().trending === 'true';
            } else {
                let cookieVal: string = this.$cookies.get(MonitoringRoomController.TRENDING_COOKIE_KEY);
                this.showTrending = (cookieVal === 'true');
            }
        }

        public searchAsType(): void {
            if (this.searchText !== undefined && this.searchText !== "") {
                this.$timeout.cancel(this.timeoutSearch);
                this.timeoutSearch = this.$timeout(() => {
                    this.applyFilter();
                }, 500);
            } else {
                this.chooseSelectedRoom();
            }
        }

        public applyFilter(): void {
            this.currentPage = 0;
            this.chooseSelectedRoom();
            if (this.searchText !== undefined && this.searchText !== "") {
                this.matchedMonitors = this.selectedMonitoringRoom.monitors.filter((monitor: Models.IMonitor) => {
                    return monitor.name.toLocaleLowerCase().indexOf(this.searchText.toLocaleLowerCase()) !== -1;
                });
            } else {
                this.matchedMonitors = this.selectedMonitoringRoom.monitors;
            }
        }

        /**
         * Modal to create a new connection room
         */
        public createMRModal(): void {
            this.modalService.showModal({
                templateUrl: Application.Controllers.GenericPromptModalController.templateUrl,
                controller: Application.Controllers.GenericPromptModalController.$name,
                inputs: {
                    title: 'Create monitoring room',
                    description: '',
                    inputName: 'Name',
                    inputRequired: true,
                    inputValue: '',
                },
            }).then((modal: ngModal.IModalObject) => {
                let promptModalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.GenericPromptModalController.id,
                    { bgclose: false, modal: false, keyboard: false });
                promptModalElem.show();
                modal.close.then((result: IGenericPromptModalResult) => {
                    promptModalElem.hide();
                    if (result) {
                        this.createMonitoringRoom(result.answer);
                    }
                });
            });
        }

        /**
         * Modal to edit a connection room
         */
        public editMRModal(): void {
            this.modalService.showModal({
                templateUrl: Application.Controllers.GenericPromptModalController.templateUrl,
                controller: Application.Controllers.GenericPromptModalController.$name,
                inputs: {
                    title: 'Edit monitoring room',
                    description: '',
                    inputName: 'Name',
                    inputRequired: true,
                    inputValue: this.selectedMonitoringRoom.name,
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.GenericPromptModalController.id,
                    { bgclose: false, modal: false, keyboard: false });
                modalElem.show();
                modal.close.then((result: IGenericPromptModalResult) => {
                    modalElem.hide();
                    if (result) {
                        this.editMonitoringRoom(result.answer);
                    }
                });
            });
        }

        /**
         * Modal to delete the selected connection room
         */
        public deleteMRModal(): void {
            let self: Controllers.MonitoringRoomController = this;

            this.modalService.showModal({
                templateUrl: Application.Controllers.ConfirmModalController.templateURL,
                controller: Application.Controllers.ConfirmModalController.$name,
                inputs: {
                    title: 'DELETE MONITORING ROOM',
                    description: 'This action cannot be undone.',
                    name: this.selectedMonitoringRoom.name,
                    type: 'information',
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.ConfirmModalController.ID,
                    { bgclose: false, modal: false, keyboard: false });
                modalElem.show();
                modal.close.then((result: string) => {
                    modalElem.hide();
                    if (result) {
                        self.deleteMonitoringRoom();
                    }
                });
            });
        }

        public aclMRModal(): void {
            this.modalService.showModal({
                templateUrl: Application.Controllers.AclModalController.templateURL,
                controller: Application.Controllers.AclModalController.$name,
                inputs: {
                    entity: this.selectedMonitoringRoom,
                    entityTypeName: 'monitorRooms',
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.AclModalController.ID,
                            {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then(() => {
                    modalElem.hide();
                });
            });
        }

        public createMonitor(): void {
            this.searchMonitorVideoStreams()
                .then((monitorVideoStream: Models.MonitorVideoStream) => {
                    let monitor: Models.IMonitor;
                    monitor = Monitor.Empty();
                    monitor.name = monitorVideoStream.name;
                    monitor.href = '';
                    monitor.source = monitorVideoStream.href;
                    monitor.monitorRoom = this.selectedMonitoringRoom.href;
                    monitor.numOrder = 0;
                    if (this.selectedMonitoringRoom.monitors !== undefined) {
                        for (let i: number = 0; i < this.selectedMonitoringRoom.monitors.length; i++)
                            if (monitor.numOrder <= this.selectedMonitoringRoom.monitors[i].numOrder)
                                monitor.numOrder = this.selectedMonitoringRoom.monitors[i].numOrder;
                        monitor.numOrder++;
                    }

                    this.monitoringRoomService
                        .saveMonitor(monitor)
                        .then((element: Models.IMonitor) => {
                            if (this.selectedMonitoringRoom.monitors !== undefined) {
                                this.selectedMonitoringRoom.monitors.push(element);
                                this.applyFilter();
                            } else {
                                this.selectedMonitoringRoom.monitors = [element];
                                this.matchedMonitors = [element];
                            }
                            for (let i: number = 0; i < this.monitoringRooms.length; i++)
                                if (this.monitoringRooms[i].href === this.selectedMonitoringRoom.href)
                                    this.monitoringRooms[i] = this.selectedMonitoringRoom;
                            this.adjustThumbnailsSize();
                            this.updatePaginationInfo();
                            this.$timeout(() => { this.currentPage = this.totalPagesRange.length - 1; });
                        });
                });
        }

        /**
         * Modal to delete a monitor
         */
        public removeMonitorModal(monitor: Models.Monitor): void {
            this.modalService.showModal({
                templateUrl: Application.Controllers.ConfirmModalController.templateURL,
                controller: Application.Controllers.ConfirmModalController.$name,
                inputs: {
                    title: 'REMOVE MONITOR',
                    description: "The stream monitoring will dissappear. Are you sure?",
                    name: '',
                    type: 'information',
                },
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.ConfirmModalController.ID,
                    { bgclose: false, modal: false, keyboard: false });
                modalElem.show();
                modal.close.then((result: string) => {
                    modalElem.hide();
                    if (result) {
                        this.removeMonitor(monitor);
                    }
                });
            });
        }

        public monitorMissing(monitor: Models.Monitor): void {
            let indexToDelete: number = -1;
            for (let i: number = 0; i < this.selectedMonitoringRoom.monitors.length; i++) {
                if (this.selectedMonitoringRoom.monitors[i].href === monitor.href) {
                    indexToDelete = i;
                }
            }
            this.selectedMonitoringRoom.monitors.splice(indexToDelete, 1);
            this.applyFilter();

        }

        public addStream(monitor: Models.Monitor): void {
            this.searchMonitorVideoStreams()
                .then((monitorVideoStream: Models.MonitorVideoStream) => {
                        monitor.source = monitorVideoStream.href;
                        return this.monitoringRoomService.saveMonitor(monitor);
                });
        }

        public changePage(page: number): void {
            this.$timeout(() => {
                this.currentPage = page;
                this.adjustThumbnailsSize();
            });
        }

        private bindEvents(): void {
            this.miniSidebarWatcher = this.$rootScope.$watch('miniSidebarActive', (newValue: boolean, oldValue: boolean) => {
                if (newValue !== oldValue)
                    this.timeoutResize = this.$timeout(() => {
                        this.adjustThumbnailsSize();
                    }, MonitoringRoomController.TIMEOUT_RESIZING);
            });

            angular.element(this.$document).ready(() => {
                this.timeoutResize = this.$timeout(() => {
                    this.adjustThumbnailsSize();
                }, 500);
                this.timeoutPagination = this.$timeout(() => {
                    this.updatePaginationInfo();
                }, 500);
            });

            this.windowWidthWatcher = this.$rootScope.$on('windowWidth', () => {
                this.timeoutPagination = this.$timeout(() => {
                    this.adjustThumbnailsSize();
                }, 100);
            });

            this.subscription = this.stompService.register(Models.CONNECTION_ROOM_COMPONENT, Models.ALL_OPERATIONS,
                (flexEvent: Models.IFlexEvent) => {
                    this.handleMonitorEvent(flexEvent);
                });

            this.$scope.$on("$destroy", () => {
                this.streamPipeService.setRequestQueueLength(1);
                this.flexCollectorService.setRequestQueueLength(1);
                this.miniSidebarWatcher();
                this.windowWidthWatcher();
                if (this.subscription)
                    this.stompService.unregister(this.subscription);
                this.$timeout.cancel(this.timeoutSearch);
                this.$timeout.cancel(this.timeoutResize);
                this.$timeout.cancel(this.timeoutPagination);
            });
        }

        private searchMonitorVideoStreams(): ng.IPromise<Models.MonitorVideoStream> {
            let deferred: ng.IDeferred<Models.MonitorVideoStream> = this.qService.defer();
            let promise: ng.IPromise<Models.MonitorVideoStream> = deferred.promise;
            let callback: (mvs: Models.MonitorVideoStream[]) => void = (monitorVideoStreams: Models.MonitorVideoStream[]) => {
                this.modalService.showModal({
                    templateUrl: Application.Controllers.MonitorVideoStreamsModalController.templateURL,
                    controller: Application.Controllers.MonitorVideoStreamsModalController.$name,
                    inputs: { monitorVideoStreams: monitorVideoStreams },
                }).then((modal: ngModal.IModalObject) => {
                    let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.MonitorVideoStreamsModalController.ID,
                        { bgclose: false, modal: false, keyboard: false });
                    modalElem.show();
                    modal.close.then((monitorVideoStream: Models.MonitorVideoStream) => {
                        modalElem.hide();
                        if (monitorVideoStream) {
                            // monitor name modal
                            this.modalService.showModal({
                                templateUrl: Application.Controllers.EditTextFieldModalController.templateURL,
                                controller: Application.Controllers.EditTextFieldModalController.$name,
                                inputs: {
                                    modalTitle: 'Edit monitor name',
                                    fieldName: 'Monitor name',
                                    fieldContent: monitorVideoStream.sourceName + ' > ' + monitorVideoStream.sinkName,
                                    dismissable: true,
                                },
                            }).then((modalName: ngModal.IModalObject) => {
                                let modalNameElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.EditTextFieldModalController.ID,
                                    { bgclose: false, modal: false, keyboard: false});
                                modalNameElem.show();
                                modalName.close.then((newName: string) => {
                                    modalNameElem.hide();
                                    if (newName !== undefined) {
                                        if (newName !== '')
                                            monitorVideoStream.name = newName;
                                        else
                                            monitorVideoStream.name = monitorVideoStream.sourceName + ' > ' + monitorVideoStream.sinkName;
                                        deferred.resolve(monitorVideoStream);
                                    }
                                });
                            }).catch((reason: ngCustom.IReason) => {
                                deferred.reject(reason);
                            });
                        }
                    });
                }).catch((reason: ngCustom.IReason) => {
                    deferred.reject(reason);
                });
            };
            this.monitoringRoomService.getAvailableStreams(callback);
            return promise;
        };

        private updatePaginationInfo(): void {
            this.$timeout(() => {
                if (this.showTrending) {
                    this.monitorsPerPage = this.$rootScope.alarmConsoleHidden ? 8 : 10;
                } else {
                    this.monitorsPerPage = this.$rootScope.alarmConsoleHidden ? 12 : 10;
                }
                if (this.selectedMonitoringRoom && this.matchedMonitors) {
                    this.totalPagesRange =
                        Common.Utils.range(Math.ceil(this.matchedMonitors.length / this.monitorsPerPage));
                    if (this.totalPagesRange.length === 0) {
                        this.totalPageNumber = 1;
                    } else {
                        this.totalPageNumber = this.totalPagesRange.length;
                    }
                }

                this.streamPipeService.setRequestQueueLength(this.amountOfMonitorsShown());
                this.flexCollectorService.setRequestQueueLength(this.amountOfMonitorsShown());
            });
        }

        private adjustThumbnailsSize(): void {
            if (this.resizeTimer !== undefined)
                this.$timeout.cancel(this.resizeTimer);
            this.updatePaginationInfo();
            this.resizeTimer = this.$timeout((): void => {
                if (this.$rootScope.alarmConsoleHidden) {
                    this.adjustThumbnailsSizeHelper($('.thumb-monitor-wrapper'), 4);
                } else {
                    this.adjustThumbnailsSizeHelper($('.thumb-monitor-wrapper'), 5);
                }
                this.firstAdjustmentDone = true;
            }, 200);
        }

        private adjustThumbnailsSizeHelper(thumbs: JQuery, elementsPerRow: number): void {
            if ((thumbs && thumbs.length <= 0) && this.matchedMonitors.length > 0) {
                this.$timeout((): void => {
                    this.adjustThumbnailsSize();
                }, 500);
                return;
            }
            let margin: number = 0.5; // percentage

            // set thumb width calculated as percentage
            let thumbWidth: number = (99.99 - margin * (elementsPerRow - 1)) / elementsPerRow;
            thumbs.css('width', thumbWidth + '%');
            thumbWidth = thumbs.width();

            let thumbHeight: number = Math.ceil(thumbWidth / MonitoringRoomController.ASPECT_RATIO);
            $('.monitor-thumbnail-source-img').height(thumbHeight);
            if (thumbHeight >= 100)
                $('.monitor-flot-chart').height(100);
            else
                $('.monitor-flot-chart').height(thumbHeight);
            if (this.showTrending) thumbHeight += $('.monitor-flot-chart').height();

            thumbs.height(thumbHeight)
                  .css('margin-right', margin + '%')
                  .css('margin-bottom', margin + '%');
            for (let i: number = 0; i < thumbs.length; i++) {
                if ((i + 1) % elementsPerRow === 0)
                    $(thumbs[i]).css('margin-right', 0);
            }

            // let frame: JQuery = $('.alarm-frame');
            // frame.height(thumbHeight);

            let rows: number = this.showTrending ? 2 : 3;
            let containerHeight: number = (thumbs.height() + 20) * rows;
            $('#monitors-container').height(containerHeight);

            if (!this.$rootScope.alarmConsoleHidden) {
                if (this.showTrending)
                    $('.panel-dots').css('margin-top', -30);
                else
                    $('.panel-dots').css('margin-top', -80);
            } else {
                $('.panel-dots').css('margin-top', 10);
            }
        }

        private loadMonitorRooms(): void {
            this.monitoringRoomService
                .getAllMonitoringRooms((monitorRooms: Models.MonitoringRoom[]) => {
                    if (!this.$cookies.get(this.cookieKey) && monitorRooms.length > 0) {
                        this.$cookies.put(this.cookieKey,
                            Common.Utils.idFromHref(monitorRooms[0].href).toString(),
                            MonitoringRoomController.COOKIE_OPTIONS);
                    }

                    this.monitoringRooms = monitorRooms;
                    Common.Utils.orderArrayByKey(this.monitoringRooms, 'name');
                    this.chooseSelectedRoom();
                    this.$timeout(() => {
                        this.updatePaginationInfo();
                        this.adjustThumbnailsSize();
                    });
                });
        }

        private chooseSelectedRoom(): void {
            if (this.monitoringRooms.length > 0) {
                this.monitoringRooms.forEach((monitorRoom: MonitoringRoom) => {
                    if (parseInt(this.$cookies.get(this.cookieKey), 10) === Common.Utils.idFromHref(monitorRoom.href)) {
                        this.selectedMonitoringRoom = monitorRoom;
                        this.matchedMonitors = monitorRoom.monitors;
                    }
                });

                if (this.selectedMonitoringRoom === undefined) {
                    this.selectedMonitoringRoom = this.monitoringRooms[0];
                    this.matchedMonitors = this.monitoringRooms[0].monitors;
                    this.$cookies.put(this.cookieKey,
                            Common.Utils.idFromHref(this.monitoringRooms[0].href).toString(),
                            MonitoringRoomController.COOKIE_OPTIONS);
                }

                this.streamPipeService.setRequestQueueLength(this.matchedMonitors.length);
                this.flexCollectorService.setRequestQueueLength(this.matchedMonitors.length);

                this.aclAservice
                    .canWrite("monitorRooms", Common.Utils.idFromHref(this.selectedMonitoringRoom.href))
                    .then((can: boolean) => {
                        this.userCanWriteRoom = can;
                    });
            }
            this.adjustThumbnailsSize();
        }

        private removeMonitor(monitor: Models.Monitor): void {
            this.monitoringRoomService.removeMonitor(monitor)
                .then(() => {
                    this.deleteMonitorFromModel(monitor.href);
                });
        }

        private amountOfMonitorsShown(): number {
            return this.totalPageNumber === this.currentPage ? this.matchedMonitors.length % this.monitorsPerPage : this.monitorsPerPage;
        }

        private createMonitoringRoom(name: string): void {
            let newMonitoringRoom: MonitoringRoom = MonitoringRoom.Empty();
            newMonitoringRoom.name = name;
            this.monitoringRoomService.saveMonitoringRoom(newMonitoringRoom)
                .then((element: Models.IMonitoringRoom) => {
                    if (this.monitoringRooms === undefined)
                        this.monitoringRooms = [element];
                    else
                        this.monitoringRooms.push(element);
                    Common.Utils.orderArrayByKey(this.monitoringRooms, 'name');
                    this.selectedMonitoringRoom = element;
                    this.matchedMonitors = element.monitors;
                    this.changeRoom();
                    this.$timeout(() => {
                        this.currentPage = 0;
                        this.searchText = "";
                        this.totalPagesRange = [undefined];
                        this.totalPageNumber = 0;
                    });
                })
                .catch((reason: ngCustom.IReason) => {
                    this.loadMonitorRooms();
                    this.messageTranslationsService
                        .getMessageAsStringByKey('err.creating.monitoring.room', newMonitoringRoom.name)
                        .then((mssg: string) => {
                            this.messageTranslationsService.alertOnError(mssg, 'bottom-center');
                        });
                });
        }

        private editMonitoringRoom(name: string): void {
            this.selectedMonitoringRoom.name = name;
            this.monitoringRoomService
                .saveMonitoringRoom(this.selectedMonitoringRoom)
                .then((monitoringRoom: MonitoringRoom) => {
                    for (let i: number = 0; i < this.monitoringRooms.length; i++)
                        if (this.monitoringRooms[i].href === monitoringRoom.href)
                            this.monitoringRooms[i].name = monitoringRoom.name;
                    this.updatePaginationInfo();
                    this.adjustThumbnailsSize();
                }).catch((reason: ngCustom.IReason) => {
                    this.loadMonitorRooms();
                    this.messageTranslationsService.showPromiseError(reason);
                });
        }

        private deleteMonitoringRoom(): void {
            this.monitoringRoomService
                .deleteMonitoringRoom(this.selectedMonitoringRoom)
                .then(() => {
                    let indexToDelete: number = -1;
                    for (let i: number = 0; i < this.monitoringRooms.length; i++)
                        if (this.monitoringRooms[i].href === this.selectedMonitoringRoom.href)
                            indexToDelete = i;
                    if (indexToDelete !== -1)
                        this.monitoringRooms.splice(indexToDelete, 1);

                    if (this.monitoringRooms === undefined || this.monitoringRooms.length === 0) {
                        this.selectedMonitoringRoom = undefined;
                        this.matchedMonitors = undefined;
                        this.$cookies.remove(this.cookieKey);
                    } else {
                        this.selectedMonitoringRoom = this.monitoringRooms[0];
                        this.matchedMonitors = this.monitoringRooms[0].monitors;
                        this.$cookies.put(this.cookieKey,
                                Common.Utils.idFromHref(this.selectedMonitoringRoom.href).toString(),
                                MonitoringRoomController.COOKIE_OPTIONS);
                        this.selectedMonitoringRoom.monitors = [];
                        this.matchedMonitors = [];
                        this.loadMonitorRooms();
                    }
                    this.updatePaginationInfo();
                    this.adjustThumbnailsSize();
                }).catch((reason: ngCustom.IReason) => {
                    this.loadMonitorRooms();
                    this.messageTranslationsService.showPromiseError(reason);
                });
        }

        /**
         * TODO: Instead of reloading all monitor rooms we need to be able to reload only the monitor change. Only in save
         */
        private handleMonitorEvent(flexEvent: Models.IFlexEvent): void {
            if (flexEvent.operation === Models.DELETE_MONITOR_OPERATION) {
                this.deleteMonitorEvent(flexEvent);
            } else if (flexEvent.operation === Models.CREATE_MONITOR_OPERATION) {
                if (flexEvent.data.monitorRoomId === Utils.idFromHref(this.selectedMonitoringRoom.href)) {
                    // we know that the monitor is on the current room because of the previous if
                    this.loadMonitorForCurrentRoom(flexEvent.data.id as number);
                }
            } else if (flexEvent.operation === Models.SAVE_MONITOR_OPERATION) {
                if (flexEvent.data.monitorRoomId === Utils.idFromHref(this.selectedMonitoringRoom.href)) {
                    this.loadMonitorRooms();
                }
            }
        }

        private deleteMonitorEvent(flexEvent: Models.IFlexEvent): void {
            for (let i: number = 0; i < this.selectedMonitoringRoom.monitors.length; i++)  {
                let thisId: number = Utils.idFromHref(this.selectedMonitoringRoom.monitors[i].href);
                if (thisId === flexEvent.data.id) {
                    // todo: call deleteMonitorFromModel with index
                    this.deleteMonitorFromModel(this.selectedMonitoringRoom.monitors[i].href);
                }
            }
        }

        private deleteMonitorFromModel(monitorHref: string): void {
            let indexToDelete: number = -1;
            for (let i: number = 0; i < this.selectedMonitoringRoom.monitors.length; i++)  {
                if (this.selectedMonitoringRoom.monitors[i].href === monitorHref) {
                    indexToDelete = i;
                }
            }
            if (indexToDelete !== -1) {
                this.selectedMonitoringRoom.monitors.splice(indexToDelete, 1);
            }

            for (let i: number = 0; i < this.monitoringRooms.length; i++)  {
                if (this.selectedMonitoringRoom.href === this.monitoringRooms[i].href) {
                    this.monitoringRooms[i].monitors = this.selectedMonitoringRoom.monitors;
                }
            }
            this.applyFilter();
            this.updatePaginationInfo();
            if (this.totalPagesRange.length - 1 <= this.currentPage)
                this.$timeout(() => { this.currentPage = this.totalPagesRange.length - 1; });
            this.adjustThumbnailsSize();
        }

        private loadMonitorForCurrentRoom(id: number): void {
            this.monitoringRoomService.getMonitor( id as number )
                .then((monitor: Models.IMonitor) => {
                    if (monitor) {   
                        // this.selectedMonitoringRoom.monitors[monitor.numOrder] = monitor;
                        if (!this.isDuplicatedMonitorNumber(monitor)) {
                            this.selectedMonitoringRoom.monitors.push(monitor);
                            this.applyFilter();
                        }
                    }

                    for (let i: number = 0; i < this.monitoringRooms.length; i++)
                        if (this.monitoringRooms[i].href === this.selectedMonitoringRoom.href)
                            this.monitoringRooms[i] = this.selectedMonitoringRoom;

                    this.$timeout(() => {
                        this.updatePaginationInfo();
                        this.adjustThumbnailsSize();
                    });
                });
        }

        private isDuplicatedMonitorNumber(monitor: Models.IMonitor): boolean {
            for (let i: number = 0; i < this.selectedMonitoringRoom.monitors.length; i++) {
                if (monitor.numOrder === this.selectedMonitoringRoom.monitors[i].numOrder) {
                    return true;
                }
            }
            return false;
        }
    }
}
